import {
    VIEW_PROJECTS_BY_OPTION_SCHEMA,
    type SearchServiceViewProjectsByOption,
} from '../type/api';

/**
 * The options for the `viewProjectsBy` filter.
 */
export const VIEW_PROJECTS_BY_OPTIONS = [
    {
        label: 'All',
        value: 'all',
    },
    {
        label: 'Our projects',
        value: 'our-projects',
    },
    {
        label: "Projects we're tagged in",
        value: 'projects-we-tagged-in',
    },
] as const satisfies readonly {
    label: string;
    value: SearchServiceViewProjectsByOption;
}[];

/**
 * Check if a string is a valid option for the `viewProjectsBy` filter.
 * @param value The string to check.
 * @returns The value if it is a valid option, `null` otherwise.
 */
export function validateViewProjectsBy(
    value?: string | null
): SearchServiceViewProjectsByOption | null {
    if (!value) {
        return null;
    }
    const result = VIEW_PROJECTS_BY_OPTION_SCHEMA.safeParse(value);
    if (result.success) {
        return result.data;
    }
    return null;
}
